import { Routes } from '@angular/router';
import { RegisterComponent } from './auth/register/register';
import { LoginComponent } from './auth/login/login';
import { loginGuard } from './auth/login.guard';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password';
import { LOAD_ROUTES } from './loads/loads.routes';
import { AVAILABILITY_ROUTES } from './availabilities/availabilities.routes';
import { MATCH_ROUTES } from './matches/matches.routes';
import { SHIPMENT_ROUTES } from './shipments/shipments.routes';
import { FLEET_ROUTES } from './fleet/fleet.routes';
import { AI_BROKER_ROUTES } from './ai-broker-chat/ai-broker.routes';
import { COMPANY_ROUTES } from './company/company.routes';
import { CUSTOMER_ROUTES } from './customer/customer.routes';
import { PublicMarketplaceComponent } from './public-marketplace/public-marketplace.component';
import { CompanyDirectoryComponent } from './company-directory/company-directory.component';
import { CompanyDetailComponent } from './company-directory/company-detail.component';
import { authGuard } from './auth/auth.guard';

export const routes: Routes = [
  {
    path: '',
    component: PublicMarketplaceComponent,
    pathMatch: 'full'
  },
  {
    path: 'public/ai-broker',
    loadComponent: () =>
      import('./public-ai-broker/public-ai-broker.component').then(
        m => m.PublicAiBrokerComponent
      )
  },
  {
    path: 'public/loads/:id',
    loadComponent: () =>
      import('./public-marketplace/public-load-details.component').then(
        m => m.PublicLoadDetailsComponent
      )
  },
  {
    path: 'public/availabilities/:id',
    loadComponent: () =>
      import('./public-marketplace/public-availability-details.component').then(
        m => m.PublicAvailabilityDetailsComponent
      )
  },
  {
    path: 'public/directory',
    loadComponent: () =>
      import('./public-marketplace/public-company-directory-list.component').then(
        m => m.PublicCompanyDirectoryListComponent
      )
  },
  {
    path: 'public/directory/:id',
    loadComponent: () =>
      import('./public-marketplace/public-company-details.component').then(
        m => m.PublicCompanyDetailsComponent
      )
  },
  ...COMPANY_ROUTES,
  ...CUSTOMER_ROUTES,
  ...LOAD_ROUTES,
  ...AVAILABILITY_ROUTES,
  ...MATCH_ROUTES,
  ...SHIPMENT_ROUTES,
  ...FLEET_ROUTES,
  ...AI_BROKER_ROUTES,
  {
    path: 'directory',
    component: CompanyDirectoryComponent,
    canActivate: [authGuard]
  },
  {
    path: 'directory/:id',
    component: CompanyDetailComponent,
    canActivate: [authGuard]
  },
  {
    path: 'register',
    component: RegisterComponent
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [loginGuard]
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  },
];
